import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'app-redeem-product-code',
  templateUrl: './redeem-product-code.component.html',
  styleUrls: ['./redeem-product-code.component.scss']
})
export class RedeemProductCodeComponent implements OnInit {
  @ViewChild('confirmRedeemModal') confirmRedeemModal: ModalComponent;
  @ViewChild('successRedeemModal') successRedeemModal: ModalComponent;
  userForm: FormGroup;
  confirmProductKeyResult: string;
  productKeyRedeemedResult: string;
  get f() { return this.userForm.controls; }

  constructor(
    private accountService: AccountService,
    private formBuilder: FormBuilder,
    private toastService: HotToastService,
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      productKey: ['', Validators.required],
    });
  }

  onSubmit() {
    this.accountService.validateProductKey(this.userForm.controls.productKey.value).subscribe(
      result => {
        this.confirmProductKeyResult = result.content;
        this.confirmRedeemModal.open();
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      }
    );
  }


  useProductKey() {
    this.accountService.redeemProductKey(this.userForm.controls.productKey.value).subscribe(
      result => {
        this.productKeyRedeemedResult = result.content;
        this.successRedeemModal.open();
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      }
    );
  }
}
